import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
 baseURL: process.env.REACT_APP_BASE_URL + "/admin/grammar",
 headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
 const token = getToken();
 if (token) {
 config.headers.Authorization = `Bearer ${token}`;
 } else {
 }
 return config;
});

const handle = (label, promise) =>
 promise
 .then((res) => {
 return { status: res.status, data: res.data };
 })
 .catch((err) => {
 return {
 status: err.response?.status || 500,
 message: err.response?.data?.message || "Request failed",
 };
 });

// ===== TOPICS =====
export const fetchGrammarTopics = (params) => {
 return handle("Fetch topics", api.get("/topic", { params }));
};
export const fetchGrammarTopicById = (id) => {
 return handle("Fetch topic by id", api.get(`/topic/${id}`));
};
export const createGrammarTopic = (data) => {
 return handle("Create topic", api.post("/topic", data));
};
export const updateGrammarTopic = (id, data) => {
 return handle("Update topic", api.put(`/topic/${id}`, data));
};
export const deleteGrammarTopic = (id) => {
 return handle("Delete topic", api.delete(`/topic/${id}`));
};

// ===== SUB-TOPICS =====
export const fetchGrammarSubTopicById = (id) => {
 return handle("Fetch sub-topic by id", api.get(`/sub-topic/${id}`));
};
export const createGrammarSubTopic = (data) => {
 return handle("Create sub-topic", api.post("/sub-topic", data));
};
export const updateGrammarSubTopic = (id, data) => {
 return handle("Update sub-topic", api.put(`/sub-topic/${id}`, data));
};
export const deleteGrammarSubTopic = (id) => {
 return handle("Delete sub-topic", api.delete(`/sub-topic/${id}`));
};
